import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    tokenRefresher_expiredAt: 'Ваш сеанс истекает через:',
    tokenRefresher_second: ' сек',
    tokenRefresher_stay: 'Оставаться в системе',
    tokenRefresher_title: 'Завершение сеанса',
    refreshToken_error: 'Не удалось получить рефреш токен'
  },
  kk: {
    tokenRefresher_expiredAt: 'соң сіздің сеансыңыз аяқталады:',
    tokenRefresher_second: ' сек',
    tokenRefresher_stay: 'Жүйеде қалу',
    tokenRefresher_title: 'Сеансты аяқтау',
    refreshToken_error: 'Жаңарту белгісін алу мүмкін болмады'
  }
});
